import { state } from './State';
import { actions } from './Actions';
import { getters } from './Getters';
import { defineStore } from 'pinia';

export const useProductStore = defineStore('product', {
  state,
  getters,
  actions,
});
